import cn from 'classnames';
import * as React from 'react';

import { IconComponent } from 'types/IconComponent';

import { withColor } from '../withColor';

import s from './withIconWrapper.module.scss';

export type IconSizeProps =
  | {
      size?: string | number;
      width?: never;
      height?: never;
    }
  | {
      size?: never;
      width?: string | number;
      height?: string | number;
    };

export type IconBaseProps = Omit<React.ComponentProps<'svg'>, 'width' | 'height' | 'color'> & {
  className?: string;
  title?: string;
};

export type IconProps = IconBaseProps & IconSizeProps & React.AriaAttributes;

export const withIconWrapper = (Component: IconComponent) => {
  return React.memo(
    withColor<IconProps>(({ className, size, width, height, ...props }) => {
      const iconWidth = width || size;
      const iconHeight = height || size;

      return (
        <Component
          className={cn(className, s.icon)}
          style={{ width: iconWidth, height: iconHeight }}
          role="img"
          {...props}
        />
      );
    }),
  );
};
